import * as React from "react";
import * as ReactDOM from "react-dom";

import {combineClassNames} from "../../Utils/ReactUtils";


export interface IChevronDropdownControlProps {
    open?: boolean;
    className?: string;
    label?: JSX.Element | JSX.Element[];
    content?: JSX.Element | JSX.Element[];
    buttonHiddenLabel?: string;
}

export interface IChevronDropdownControlState {
    open?: boolean;
    className?: string;
}

export class ChevronDropdownControl extends React.Component<IChevronDropdownControlProps, IChevronDropdownControlState> {
    contentContainer: React.ReactInstance;
    familyId: string;

    constructor(props) {
        super(props);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.state = {
            open: props.open,
            className: props.className
        }
        this.familyId = Math.random().toString(24).substr(2, 12);
    }

    private documentClicked = (ev: MouseEvent) => {
        if (this.state.open) {
            if (ev.defaultPrevented)
                return;
            let target = ev.srcElement;
            while (target) {
                if (target.className.toString().indexOf(this.familyId) >= 0) {
                    return;
                }
                target = target.parentElement;
            }
            this.setState({
                open: false
            });
        }
    }

    private chevronClicked = (ev: React.MouseEvent<any>) => {
        let element = ev.nativeEvent.srcElement || (ev.nativeEvent.target as Element);
        if (element.className.toString().indexOf(this.familyId) < 0)
            return;
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            open: !this.state.open
        });
    }

    componentDidUpdate(prevProps: IChevronDropdownControlProps, prevState: IChevronDropdownControlState) {
        if (!prevState.open && this.state.open) {
            this.focusInput(0, 1);
        }
    }

    componentDidMount() {
        document.body.addEventListener("click", this.documentClicked);

        if (this.state.open) {
            this.focusInput(0, 1);
        }
    }

    componentWillUnmount() {
        document.body.removeEventListener("click", this.documentClicked);
    }

    public close() {
        this.setState({
            open: false
        });
    }

    handleKeyDown(evt) {
        if (evt.keyCode === 27) {
            evt.stopPropagation();
            this.close();
        }
    }

    focusInput(from: number, to?: number) {
        const channelFilterElement = ReactDOM.findDOMNode(this.contentContainer);
        const allInputs = channelFilterElement ? channelFilterElement.querySelectorAll('input:not([type="radio"]), input[type="radio"]:checked') : [];
        const focusing = [].slice.call(allInputs, from, to);

        if (focusing[0]) {
            focusing[0].focus();
        }
    }

    render() {
        let open = (this.state.open) ? "open" : "";
        let visible = (this.state.open) ? "visible" : "";
        return (
            <div
                className={ combineClassNames("chevron-dropdown", this.state.className) }
                onKeyDown={ this.handleKeyDown }
                role="group"
            >
                <div className={ combineClassNames("label") }>
                    { this.props.label }
                </div>
                <button
                    className={ combineClassNames("chevron", "m-icon-ChevronDown", open, this.familyId)} onClick={(ev) => this.chevronClicked(ev) }
                    aria-expanded={ this.state.open }
                >
                    <span className="offscreen">
                        { this.props.buttonHiddenLabel }
                    </span>
                </button>
                <div
                    className={ combineClassNames("content", visible, this.familyId) }
                    ref={ instance => this.contentContainer = instance }
                    role="menu"
                >
                    <div
                        className="offscreen"
                        onFocus={ () => this.focusInput(-1) }
                        tabIndex={ 0 }
                    />
                    { this.props.content }
                    <div
                        className="offscreen"
                        onFocus={ () => this.focusInput(0, 1) }
                        tabIndex={ 0 }
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/ChevronDropdownControl.tsx